export default "<narwhalia-population-sidebar class=\"sidebar\"></narwhalia-population-sidebar>\r\n<narwhalia-population-list></narwhalia-population-list>\r\n";